import {CHANNEL_CONTENT, PRODUCTION_CONTENT, PAGE_CONTENT, LOAD_BUTTON_TEXT} from "../types";

const initialState = {
    channelContent: false,
    productionsContent: false,
    pageContent: false,
    loadButtonText: '', // текст кнопки скачивания каталога, нужен на всех страницах
}

export const channelContentReducer = (state = initialState, action) => {
    const { type, payload } = action
    switch (type) {
        case CHANNEL_CONTENT:
            return{
                ...state,
                channelContent: payload,
            };
        case PRODUCTION_CONTENT:
            return{
                ...state,
                productionsContent: payload,
            };
        case PAGE_CONTENT:
            return{
                ...state,
                pageContent: payload,
            };
        case LOAD_BUTTON_TEXT:
            return{
                ...state,
                loadButtonText: payload,
            };
        default:
            return state;
    }
}
